/* Shared report helpers and primitive components */
export const sc = s => s >= 70 ? "#065F46" : s >= 45 ? "#92400E" : "#B91C1C";
export const scBg = s => s >= 70 ? "#D1FAE5" : s >= 45 ? "#FEF3C7" : "#FEE2E2";
export const scLabel = s => s >= 70 ? "Strong" : s >= 45 ? "Needs Work" : "Critical";
export const fmt$ = n => "$" + Math.floor(n).toLocaleString("en-US");
